// extracted by mini-css-extract-plugin
export default {"root":"profile_preview_header-module___root___f36c785c","title":"profile_preview_header-module___title___c1b8a495"};